export default __webpack_public_path__ + "static/media/logo.ac643421.png";